import { ApplicationRole, AppUserStatus } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { AppUserListEntry } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { UserData } from '../../../../../adl-gen/totalinteraction/futurefit/requests';
import { ListFieldInfo } from '../../../common/list/list-types';

/** Display information for Users */
export const AppUserListView: ListFieldInfo<AppUserListEntry, UserData>[] = makeAppUserListView([]);

/// Builds the user list fields, resolving each user's manager (AppUser.managerId)
/// to a name from the given list of users
export function makeAppUserListView(users: AppUserListEntry[]): ListFieldInfo<AppUserListEntry, UserData>[] {
  const fullnameById: { [id: string]: string } = {};
  users.forEach(u => {
    fullnameById[u.id] = u.fullname;
  });
  return [
    {
      name: 'fullname',
      label: 'Name',
      kind: 'link',
      displayed: true,
      sortable: true,
      compare: (a: AppUserListEntry, b: AppUserListEntry) => sortBySurname(a.fullname.trim(), b.fullname.trim()),
      searchable: true
    },
    { name: 'email', label: 'Email', kind: 'text', displayed: true, sortable: true, searchable: true },
    {
      name: 'managerId',
      label: "User's Manager",
      kind: 'mapped',
      displayed: true,
      sortable: false,
      map: entry => (entry.managerId && fullnameById[entry.managerId]) || 'None',
      align: 'centre'
    },
    {
      name: 'role',
      label: 'User Type',
      kind: 'mapped',
      displayed: true,
      sortable: false,
      map: entry =>
        entry.role === ApplicationRole.super ? 'super' : entry.role === ApplicationRole.admin ? 'admin' : 'user',
      align: 'centre'
    },
    {
      name: 'status',
      label: 'Active',
      kind: 'checkItem',
      displayed: true,
      toggle: entry => entry.status === AppUserStatus.active,
      align: 'centre'
    },
    {
      name: 'memberOf',
      label: 'Member Of',
      kind: 'selectList',
      displayed: true,
      map: (entry, data: UserData) => {
        if (entry.memberOf.length === 0) {
          return [{ label: 'None', value: 'none' }];
        }
        return entry.memberOf.map(m => {
          const group = data.groupList.find(g => g.id === m.value.userGroupId);
          return { label: group ? group.value.name : 'notfound', value: m.value.userGroupId };
        });
      },
      align: 'centre'
    },
    {
      name: 'managerOf',
      label: 'Manager Of',
      kind: 'selectList',
      displayed: true,
      map: (entry, data: UserData) => {
        if (entry.managerOf.length === 0) {
          return [{ label: 'None', value: 'none' }];
        }
        return entry.managerOf.map(m => {
          const group = data.groupList.find(g => g.id === m.value.userGroupId);
          return { label: group ? group.value.name : 'notfound', value: m.value.userGroupId };
        });
      },
      align: 'centre'
    },
    {
      name: 'completed',
      label: 'Completed Assessments',
      kind: 'mapped',
      displayed: true,
      sortable: false,
      map: entry => `${entry.quizzes.filter(q => q.value.completedAt !== null).length}`,
      align: 'centre'
    },
    {
      name: 'pending',
      label: 'Pending Assessments',
      kind: 'mapped',
      displayed: true,
      sortable: false,
      map: entry => `${entry.quizzes.filter(q => q.value.completedAt === null).length}`,
      align: 'centre'
    }
  ];
}

const sortBySurname = (a: string, b: string) => {
  // Sort by the last available name where space-separated
  // Cater for the less-common case of three names
  const nameCountA = a.split(' ').length;
  const nameCountB = b.split(' ').length;
  let surnameA = a;
  let surnameB = b;
  let firstnameA = a;
  let firstnameB = b;
  if (nameCountA > 1) {
    surnameA = surnameA.split(' ').slice(-1)[0];
    firstnameA = firstnameA.split(' ')[0];
  }
  if (nameCountB > 1) {
    surnameB = surnameB.split(' ').slice(-1)[0];
    firstnameB = firstnameB.split(' ')[0];
  }
  return surnameA.localeCompare(surnameB) || firstnameA.localeCompare(firstnameB);
};



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/appuser-list/appuser-list-view.ts